<template>
  <div class="flex gap-2 items-center">
    <jade-button
      size="medium"
      variant="neutral-ghost"
      icon="circle-help"
      @click="handleShowHelpCenter"
    >
      {{ $t('general.help') }}
    </jade-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { JadeButton } from '@jade'
import Amplitude from '@/amplitude-events/resume.amplitude'

export default {
  name: 'HomeNavigationBarActions',
  components: {
    JadeButton
  },
  computed: {
    ...mapGetters({
      showHelpCenter: 'GET_DRAWER_HELP_CENTER'
    })
  },
  methods: {
    ...mapActions(['TOGGLE_DRAWER_HELP_CENTER']),
    handleShowHelpCenter () {
      this.TOGGLE_DRAWER_HELP_CENTER()
      Amplitude.events.actions.helpCenterClicked({
        open: this.showHelpCenter
      })
    }
  }
}
</script>
